'use strict';

var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Channel = require('ipfs-pubsub-1on1');

var Logger = require('logplease');

var logger = Logger.create("exchange-heads", {
  color: Logger.Colors.Yellow
});
Logger.setLogLevel('ERROR');

var getHeadsForDatabase = function getHeadsForDatabase(store) {
  return store && store._oplog ? store._oplog.heads : [];
};

var exchangeHeads =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ipfs, address, peer, getStore, getDirectConnection, onMessage, onChannelCreated) {
    var _handleMessage, channel, heads;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _handleMessage = function _handleMessage(message) {
              var msg = JSON.parse(message.data);
              var address = msg.address,
                  heads = msg.heads;
              onMessage(address, heads);
            };

            channel = getDirectConnection(peer);

            if (channel) {
              _context.next = 16;
              break;
            }

            _context.prev = 3;
            logger.debug("Create a channel to ".concat(peer));
            _context.next = 7;
            return Channel.open(ipfs, peer);

          case 7:
            channel = _context.sent;
            channel.on('message', _handleMessage);
            logger.debug("Channel created to ".concat(peer));
            onChannelCreated(channel);
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](3);
            logger.error(_context.t0);

          case 16:
            _context.next = 18;
            return channel.connect();

          case 18:
            logger.debug("Connected to ".concat(peer)); // Send the heads if we have any

            heads = getHeadsForDatabase(getStore(address));
            logger.debug("Send latest heads of '".concat(address, "':\n"), JSON.stringify(heads.map(function (e) {
              return e.hash;
            }), null, 2));

            if (heads) {
              channel.send(JSON.stringify({
                address: address,
                heads: heads
              }));
            }

            return _context.abrupt("return", channel);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 13]]);
  }));

  return function exchangeHeads(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = exchangeHeads;